import { FC } from 'react';

const iconCoffeeCup = require('./icon_coffee_cup.svg');

export const IconCoffeeCup: FC = () => {
  return <img alt="icon_coffee_cup" height={87} src={iconCoffeeCup} width={71} />;
};

IconCoffeeCup.displayName = 'IconCoffeeCup';
